import { Component, Input, OnInit } from '@angular/core';
import { Machine } from '../masterdata/models/machine';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ActivatedRoute } from '@angular/router';
import { ProcessFlow } from '../masterdata/models/processFlow';

@Component({
  styleUrls: ['./ma-samples.component.css'],
  selector: 'app-ma-samples',
  templateUrl: './ma-samples.component.html'
})
export class MaSamplesComponent implements OnInit {

  selectedLabId: string;
  blocked = false;
  index: number = 0;
  machinesList: Machine[] = [];
  platePreparationTabActive = false;
  beadChipLoadingTabActive = false;
  resultEvaluationTabActive = false;
  scannedPlateID: string = null;
  entityType: string = null;
  isResultEvaluationOn = true;
  selectedProcessFlows: ProcessFlow[];

  constructor(private activatedroute: ActivatedRoute, private masterDataService: MasterDataService) { }

  ngOnInit() {
    this.updateSelectedProcessFlowProperties();
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id; 
    this.fetchMachines();
    this.activatedroute.params.subscribe(
      params => {
         this.scannedPlateID = params['id'];
         let tabIndex = params['tab'];
         this.entityType = params['entity'];
         if(this.scannedPlateID && tabIndex) {
          this.onTabChange({index : +tabIndex});
        }
      }
   );
  }


  onTabChange(event) {
    this.fetchMachines();
    this.updateSelectedProcessFlowProperties();
    switch (event.index) {
      case 0:
        this.platePreparationTabActive = true;
        this.beadChipLoadingTabActive = false;
        this.resultEvaluationTabActive= false;
        break
      case 1:
        this.platePreparationTabActive = false;
        this.beadChipLoadingTabActive = true;
        this.resultEvaluationTabActive= false;
        break
      case 2:
        this.platePreparationTabActive = false;
        this.beadChipLoadingTabActive = false;
        this.resultEvaluationTabActive= true;
        break;
      default:
        break;
    }
    this.index = event.index;
  }

  fetchMachines(){
    this.masterDataService.getConfigList(this.selectedLabId, "machine", 0, 1000).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.machinesList = results.data;
      }
    )
  }

  updateSelectedProcessFlowProperties(){
    this.selectedProcessFlows = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    this.isResultEvaluationOn = false;
    for(let i=0; i<this.selectedProcessFlows.length; i++){
      if(this.selectedProcessFlows[i].resultEvaluation){
        this.isResultEvaluationOn = true;
        break
      }
    }
  }

  getCSSClassForPanel(index: number){
    if(index == this.index){
      return 'selected';
    }else{
      return 'unselected';
    }
  }
}
